import { IPreviewPublicationRequest } from '../../../../model/sdp/official-daily/request/preview-publication-request';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

// Categorias com regras próprias no formulário
export const PUBLIC_ACCOUNT_CATEGORY_ID = 2;
export const BIDDING_CATEGORY_ID = 3;
export const DEFAULT_BIDDING_COMMISSION = 'Comissão Permanente de Licitação';

export type PublicationField = 'clientId' | 'publicationDateOn' | 'categoryId' | 'subcategoryId' | 'publicAgencyId' | 'documentTypeId' | 'description';

export function validatePublicationRequest(request: Partial<IPreviewPublicationRequest>): ValidationErrors<PublicationField> {
    const errors: ValidationErrors<PublicationField> = {};
    if (isEmptyId(request.clientId)) errors.clientId = 'Selecione a entidade';
    if (isBlank(request.publicationDateOn)) errors.publicationDateOn = 'Informe a data da publicação';
    if (isEmptyId(request.categoryId)) errors.categoryId = 'Selecione a categoria';
    if (isEmptyId(request.subcategoryId)) errors.subcategoryId = 'Selecione a subcategoria';
    if (isEmptyId(request.publicAgencyId)) errors.publicAgencyId = 'Selecione o órgão de publicação';
    if (isEmptyId(request.documentTypeId)) errors.documentTypeId = 'Selecione o tipo de documento';
    if (isBlank(request.description)) errors.description = 'Informe a descrição';
    return errors;
}

export function isBiddingCategory(categoryId?: number): boolean {
    return categoryId === BIDDING_CATEGORY_ID;
}

// Ao trocar a categoria, limpa os campos dependentes e preenche a comissão padrão de licitação
export function getCategoryChanges(categoryId?: number): Partial<IPreviewPublicationRequest> {
    const bidding = isBiddingCategory(categoryId);
    return {
        categoryId,
        subcategoryId: undefined,
        number: '',
        descriptionCommission: bidding ? DEFAULT_BIDDING_COMMISSION : '',
        descriptionPresidentCommission: '',
        sanctionDateOn: undefined,
    };
}
